import { uuid } from "@/modules/builder/utils/utils"

export default {
	namespaced: true,
	state: {
		datas: [],
		default_object: {
			id: 0,
			content: null
		}
	},
	getters: {
		datas: state => state.datas,
		component: state => id => state.datas.find(x => x.id == id) ? state.datas.find(x => x.id == id).content : null
	},
	mutations: {
		/* editor */
		PUSH_DATA(state, val) {
			state.datas.push(val)
		},
		KILL(state) {
			state.data = []
		}

		/* nodi */
	},
	actions: {
		async pushEl({ state, commit, rootState, dispatch }, { val, id }) {
			var el = await dispatch("newObj")

			el.content = val

			if (id) {
				el.id = id + uuid()
			}

			commit("PUSH_DATA", el)


			return `${el.id}`
		},

		newObj({ state, commit, rootState, dispatch }) {
			var tmp = JSON.parse(JSON.stringify(state.default_object))
			tmp.id = state.datas.length

			return tmp
		},

		kill({ state, commit, rootState, dispatch }) {
			commit("KILL")
		}
	}
}
